import { createManageRolesTable } from '../../../../components/AdminUsersPage/ManageRolesTab/createManageRolesTable.ts';
import { $$roles } from '../../../../services/RolesService/model.ts';

export const $$ghsAdminManageRolesTable = createManageRolesTable({
  getManageableRolesFx: $$roles.adminGetManageableRolesFx
});